<template>

  <ob-dialog :heading="$t('interventions.product-options')" @ok="ok()" @cancel="close()">
    <v-text-field autofocus step="1" type="number" v-model="values.quantity" :label="$t('interventions.product-quantity')"></v-text-field>
    <v-text-field type="number" v-model="values.price" :label="$t('interventions.product-price')"></v-text-field>
  </ob-dialog>

</template>

<script>

import ObDialog from '../../shared/components/dialog'

export default {
  name: 'product-options-dialog',

  props: [ 'product' ],

  data () {
    return {
      values: {}
    }
  },

  methods: {
    ok () {
      this.$emit('submit', this.values)
    },

    close () {
      this.$emit('submit', false)
    },
  },

  mounted () {
    this.values = JSON.parse(JSON.stringify(this.product))
  },

  components: {
    ObDialog
  }
}

</script>
